import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-info-speech",
  "use": "icon-info-speech-usage",
  "viewBox": "0 0 20 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 18\" id=\"icon-info-speech\">\r\n  <path id=\"icon-info-speech_iconmonstr-info-12\" d=\"M20,14.893H9.167L3.333,19V14.893H0V1H20ZM18.333,2.636H1.667v10.62H5v2.557l3.631-2.557h9.7Zm-7.5,4.91v4.091H9.167V7.546ZM10,6.319A1.023,1.023,0,1,0,8.958,5.3,1.033,1.033,0,0,0,10,6.319Z\" transform=\"translate(0 -1)\" fill=\"currentColor\" fill-rule=\"evenodd\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol